var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FBEBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.35 29.68a3.63 3.63 0 0 1-3.4 2.32h-5.9a3.62 3.62 0 0 1-3.4-2.32c-.55-1.42-.17-2.99.95-4.01L20.65 22h2.71l4.04 3.67a3.635 3.635 0 0 1 .95 4.01z",
    fill: "#FF5958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.82 28.14h-3.64a.68.68 0 0 1 0-1.36h3.64c.38 0 .68.31.68.68 0 .37-.31.68-.68.68z",
    fill: "#FBEBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.35 14.32a3.63 3.63 0 0 0-3.4-2.32h-5.9a3.63 3.63 0 0 0-2.44 6.33L20.65 22h2.71l4.04-3.67a3.635 3.635 0 0 0 .95-4.01zm-4.53 2.91h-3.64a.68.68 0 0 1-.68-.68c0-.37.31-.68.68-.68h3.64c.38 0 .68.31.68.68 0 .37-.31.68-.68.68z",
    fill: "#FF5958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timerIcon.a3f1790447bca5f8aca35d78440b9788.svg";
export { ForwardRef as ReactComponent };